/**
 * Created by claudio iozzia on 04/07/2017.
 */
import {Validator_DcDc_BuckBoost} from "./dcdc_buck_boost_validator";
import {Ic, IEntityAlert} from "../../../../models/common";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Utils} from "../../../../common/utils";
import {EntityError} from "../../../../models/EntityAlert";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";

export class Validator_DcDc_InvertingBuckBoost extends Validator_DcDc_BuckBoost {

  private calculate_voutUpperBound(ic: Ic, spec: IAppSpec): number {
    const _vin = spec.spec.value.input;
    const isAttendibileVinMax: boolean = !spec.spec.note.input.max.hasError && isFinite(_vin.max);
    return isAttendibileVinMax ? ic.vout_max - _vin.max : ic.vout_max;
  }

  private validatorFn_SingleOutput_Voltage_InvertingBuckBoost: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vOut = Math.abs(spec.spec.value.output.outputs[o].voltage);
    const vOutUpperBound = this.calculate_voutUpperBound(a, spec);
    const result = Utils.acceptInRange(_vOut, a.vout_min, vOutUpperBound, "Vout", "V");

    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_InvertingBuckBoost: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vin = spec.spec.value.input;
    const _vOut = spec.spec.value.output.outputs[o];
    const isAttendibileVinMin: Boolean = !spec.spec.note.input.min.hasError && Utils.isValueReal(_vin.min);
    const isFiniteVout: boolean = Utils.isValueReal(_vOut.voltage);

    let maxIout: number = ic.iout_max;
    if (isAttendibileVinMin && isFiniteVout) {
      const idealDuty: number = Math.abs(_vOut.voltage) / (Math.abs(_vOut.voltage) + _vin.min);
      const maxIoutForDuty: number = ValueFormatter.scale(maxIout * (1 - idealDuty), siPrefix.unit);
      maxIout = Math.min(maxIout, maxIoutForDuty);
    }
    const result = Utils.acceptUpTo(_vOut.current, maxIout, "Iout", "A");

    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_InvertingBuckBoost];
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_InvertingBuckBoost];
  }

}
